import React from 'react';
import {
  Paper,
  List,
  ListItem,
  TextField,
  Box,
  Typography,
} from '@mui/material';

export default function GroupAdjustment(props) {
  const {
    maxRate,
    groupBreaks,
    fullFieldAdjustment,
    onFullFieldChange,
    groupAdjustments,
    onGroupChange,
  } = props;

  const adjustments = groupAdjustments.reduce(
    (acc, cur) => ({ ...acc, [cur.minvalue]: cur.adjustmentFactor }),
    {},
  );

  const groups = groupBreaks.map((key) => ({
    minvalue: key,
    adjustmentFactor: adjustments[`${key}`] || '',
  }));

  const itemsPerColumn = Math.ceil(groups.length / 3);
  const column1 = groups.slice(0, itemsPerColumn);
  const column2 = groups.slice(itemsPerColumn, itemsPerColumn * 2);
  const column3 = groups.slice(itemsPerColumn * 2);
  const columns = [column1, column2, column3].filter((c) => c.length);

  return (
    <>
      <TextField
        variant="standard"
        label="Full Field Adjustment"
        InputLabelProps={{ shrink: true }}
        value={fullFieldAdjustment}
        onChange={handleFullFieldChange}
      />
      <Box display="flex">{columns.map(buildColumn)}</Box>
    </>
  );

  function buildColumn(column, i) {
    return (
      <Box marginTop="16px" marginRight="16px" key={i}>
        <Paper>
          <List>
            {column.map((group) => (
              <ListItem key={group.minvalue}>
                <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                  <Typography variant="body1">
                    {`Original ${Number(group.minvalue).toFixed(1)}`}
                  </Typography>
                  <TextField
                    variant="standard"
                    value={group.adjustmentFactor}
                    InputLabelProps={{ shrink: true }}
                    margin="normal"
                    onChange={handleGroupChange.bind(null, group.minvalue)}
                  />
                  <Typography variant="body1">
                    {`Adjusted ${getAdjustedValue(group)}`}
                  </Typography>
                </Box>
              </ListItem>
            ))}
          </List>
        </Paper>
      </Box>
    );
  }

  function handleFullFieldChange(e) {
    if (!isValidAdjustment(e)) return;
    onFullFieldChange(e.target.value);
  }

  function handleGroupChange(groupValue, e) {
    if (!isValidAdjustment(e)) return;
    onGroupChange(groupValue, e.target.value);
  }

  function getAdjustedValue({ minvalue, adjustmentFactor }) {
    return adjustGroup(minvalue, adjustmentFactor).toFixed(1);
  }

  function adjustGroup(value, adjustment) {
    const adjusted = Number(value) + Number(adjustment);
    if (adjusted < 0) return 0;
    if (adjusted > maxRate) return maxRate;
    return Number.isNaN(adjusted) ? value : adjusted;
  }

  function isStartOfValidAdjustment(value) {
    return /^-?\.?$/.test(value);
  }

  function isValidAdjustment(e) {
    const stringValue = e.target.value;
    if (stringValue.match(/ /)) return false;
    if (isStartOfValidAdjustment(stringValue)) return true;
    const numericValue = Number(stringValue);
    if (Number.isNaN(numericValue)) return false;
    const parts = stringValue.split('.');
    return parts.length === 1 || (parts.length === 2 && parts[1].length < 2);
  }
}
